export const generateEditLinkForUsers = id => `/panelUsers/edit?userID=${id}`;
